const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
const Sword = require('../../../game_items/equipment/weapon/Sword.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const skeleton = (level) => {
  const handle = 'skeleton';
  const types = ['skeleton', 'undead'];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(MedTorsoe, level),
          ItemGenerator.getCavernsMobItem(Sword, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'skeleton_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          slash: {
            handle: 'slash',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(2 + bound_level * 0.3 + Math.random() * 3),
      perception: Math.round(3 + bound_level * 0.55 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      toughness: Math.round(2 + bound_level * 0.3 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.55 + Math.random() * 3),
      willpower: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      dexterity: Math.round(3 + bound_level * 0.8 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
    xpValue: level * 35,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }, { value: 'slash' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = skeleton;
